import { Pipe, PipeTransform } from '@angular/core';
import { formatNumber, format, ParsedNumber, parseNumber } from 'libphonenumber-js';

@Pipe({
  name: 'phoneThing'
})
export class PhonePipe implements PipeTransform {

  transform(value: ParsedNumber, args?: string): any {
    if (!value) {
      return value;
    }
    //console.log(parseNumber(value.toString(), 'US'));
    //console.log(formatNumber(parseNumber(value.toString(), 'US'), 'National'));
    //console.log(value.toString());
    let number = parseNumber(value.toString());
    if (!Object.keys(number).length) {
      return value;
    }
    if (value.toString().startsWith("+"))
      return formatNumber(number, 'International');
    else
      return formatNumber(number, 'National');
  }
}
